import { mergeMap, tap } from 'rxjs/operators';
// RxJS
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../../_base/crud';
// State
import { AppState } from '../../../reducers';
import { selectDeliveryChallanInStore, selectDeliveryChallanPageLoading, selectDeliveryChallanShowInitWaitingMessage } from '../_selectors/deliveryChallan.selectors';

export class DeliveryChallanDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectDeliveryChallanPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectDeliveryChallanShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectDeliveryChallanInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
